import * as moment from 'moment';
import {Dictionary} from './dictionary.model';

export class Member {
  id: number;
  name: string;
  firstName: string;
  secondName: string;
  lastName: string;
  birthday: any;
  comment: string;
  email: string;
  phone: string;
  ageType: Dictionary;
  disabled?: boolean;

  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    this.firstName = apiModel.first_name;
    this.secondName = apiModel.second_name;
    this.lastName = apiModel.last_name;
    if (apiModel.second_name) {
      this.name = `${apiModel.first_name} ${apiModel.second_name} ${apiModel.last_name}`;
    } else {
      this.name = `${apiModel.first_name} ${apiModel.last_name}`;
    }
    this.email = apiModel.email;
    this.phone = apiModel.phone;
    this.comment = apiModel.comment;
    if (apiModel.birthday) {
      this.birthday = moment(apiModel.birthday);
    }
    this.ageType = apiModel.age_category ? new Dictionary().setFromApiModel(apiModel.age_category) : null;
    return this;
  }
}
